import { PlaneRadiusVector } from './plane-radius-vector';

export class PlaneArc {
    constructor(
        public center: PlaneRadiusVector,
        public radius: number,
        public startAngle: number,
        public endAngle: number,
        public anticlockwise: boolean
    ) {
    }
}
